export default {
  messages: {
    manager: `ORES ist nicht der Betreiber der Strom- und Erdgasverteilernetze oder ORES hat kein Gasverteilernetz in der ausgewählten Ortschaft. Sie können <a href=\"http://www.synergrid.be/index.cfm?PageID=16823\" target=\"_blank\">hier</a> den Verteilernetzbetreiber Ihrer Gemeinde finden.`,
    house_number_valid_characters: `Die Hausnummer darf nur Buchstaben, Zahlen, Leerzeichen, Bindestriche und Schrägstriche enthalten.`,
    name_valid_characters: 'Der Name enthält unzulässige Zeichen. Folgende Zeichen sind nicht erlaubt: < > \\ : ; " = sowie Zeilenumbrüche. Die Sequenzen //, /*, */ und -- sind ebenfalls verboten.',
  }
}
